(() => {
  'use strict';

  const root = document.documentElement;
  const params = new URLSearchParams(location.search);
  const testCookie = params.get('cookie_banner_test') === '1';
  const wait = (milliseconds) => new Promise(resolve => window.setTimeout(resolve, milliseconds));
  let introFinished = root.classList.contains('fg-intro-skip') || root.classList.contains('fg-intro-done');
  let started = false;

  const releaseCookieBanner = () => {
    root.classList.remove('fg-popup-sequence-pending');
    root.classList.add('fg-popup-sequence-cookie-ready');
  };

  const releaseNewsletter = (reason) => {
    window.dispatchEvent(new CustomEvent('58g:newsletter-ready', { detail: { reason } }));
  };

  const loadPrivacyApi = () => new Promise(resolve => {
    if (testCookie) {
      resolve({ shouldShowBanner: () => true });
      return;
    }
    if (window.Shopify?.customerPrivacy) {
      resolve(window.Shopify.customerPrivacy);
      return;
    }
    if (!window.Shopify?.loadFeatures) {
      resolve(null);
      return;
    }
    window.Shopify.loadFeatures([
      { name: 'consent-tracking-api', version: '0.2' }
    ], error => resolve(error ? null : window.Shopify?.customerPrivacy || null));
  });

  const run = async () => {
    if (started || !introFinished) return;
    started = true;

    const privacyApiPromise = loadPrivacyApi();
    await wait(1000);
    const privacyApi = await privacyApiPromise;
    const consentBannerExists = Boolean(document.querySelector('#shopify-pc__banner'));
    const needsConsent = testCookie || Boolean(privacyApi?.shouldShowBanner?.() && consentBannerExists);

    releaseCookieBanner();

    if (!needsConsent) {
      await wait(6000);
      releaseNewsletter('no-consent-required');
      return;
    }

    document.addEventListener('visitorConsentCollected', async () => {
      await wait(5000);
      releaseNewsletter('consent-collected');
    }, { once: true });
  };

  window.addEventListener('58g:intro-complete', () => {
    introFinished = true;
    run();
  }, { once: true });

  run();
})();
